import { useState } from 'react'
import { getLoginUrl, getSignupUrl } from '../../config/surface'

/**
 * Marketing Surface header — spec §9. Deliberately no auth-state check
 * (see App.tsx / spec §17): always shows "登录" / "免费开始使用", never
 * imports `AuthContext` (Marketing never depends on Tenant/session state,
 * keeping the Surface boundary — spec §3 — a real, checkable property).
 */
export default function Header() {
  const [open, setOpen] = useState(false)

  return (
    <header className="mkt-header">
      <div className="mkt-header-inner">
        <a className="mkt-brand" href="#top">
          <span className="mkt-brand-mark">V</span>
          Vistoera
        </a>

        <nav className="mkt-nav-links">
          <a href="#features">功能</a>
          <a href="#workflow">工作流程</a>
          <a href={getLoginUrl()}>登录</a>
          <a href={getSignupUrl()}>免费开始使用</a>
        </nav>

        <div className="mkt-nav-cta">
          <a className="mkt-btn mkt-btn-ghost" href={getLoginUrl()}>
            登录
          </a>
          <a className="mkt-btn mkt-btn-primary" href={getSignupUrl()}>
            免费开始使用
          </a>
        </div>

        <button
          type="button"
          className="mkt-nav-toggle"
          aria-label="打开导航菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? '✕' : '☰'}
        </button>
      </div>

      <div className={`mkt-nav-mobile${open ? ' open' : ''}`}>
        <a href="#features" onClick={() => setOpen(false)}>
          功能
        </a>
        <a href="#workflow" onClick={() => setOpen(false)}>
          工作流程
        </a>
        <a href={getLoginUrl()} onClick={() => setOpen(false)}>
          登录
        </a>
        <a href={getSignupUrl()} onClick={() => setOpen(false)}>
          免费开始使用
        </a>
      </div>
    </header>
  )
}
